export const getDataFromMaybeSerialized = (
  serializedData: string | object = '{}'
) => {
  const parsedData =
    typeof serializedData === 'string'
      ? JSON.parse(serializedData)
      : serializedData;

  return parsedData;
};
